import React from 'react';
import { Col } from 'antd';
import { SectorFormItem } from '@/components/views/Resolution886/components/Form';

export function Sector(): JSX.Element {
	return (
		<Col xs={24}>
			<SectorFormItem fieldName="sector_id" required={false} />
		</Col>
	);
}
